import * as actionType from '../actionTypes/actionTypes';

// action creater for frontend skills
export const setFrontendSkills = (skills) => ({
  type: actionType.SET_FRONTEND_SKILLS,
  payload: skills,
});

// action creater for backend skills
export const setBackendSkills = (skills) => ({
  type: actionType.SET_BACKEND_SKILLS,
  payload: skills,
});

// action creator for Tools
export const setToolSkills = (skills) => ({
  type: actionType.SET_TOOL_SKILLS,
  payload: skills,
});

export const setCommunicationSkills = (skills) => ({
  type: actionType.SET_COMMUNICATION_SKILLS,
  payload: skills,
});

export const setSoftSkills = (skills) => ({
  type: actionType.SET_SOFT_SKILLS,
  payload: skills,
});

// Action create for Projects Data
export const setAllProjectsData = (data) => ({
  type: actionType.SET_ALL_PROJECTS_DATA,
  payload: data,
});

// Action create for Testimonials Data
export const setTestimonialsData = (data) => ({
  type: actionType.SET_ALL_TESTIMONIALS_DATA,
  payload: data,
});
